import { useState } from 'react';
import { Link } from 'react-router-dom';
import Panel from '~/components/Panel';
import MedicalProfessionalDrawer from '~/components/MedicalProfessionalDetail/drawers/MedicalProfessionalDrawer';

interface Props {
    medProf: any;
    professionalChoices: any;
}

const MedicalProfessionalPanel: React.FC<Props> = ({
    medProf,
    professionalChoices,
}) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [medicalProf, setMedicalProf] = useState(medProf);
    return (
        <>
            <Panel>
                <div className='flex place-content-between items-start'>
                    <div className='w-full xl:w-5/6'>
                        <div className='flex flex-wrap'>
                            <div className='mb-[16px] w-1/3'>
                                <label className='text-[12px]/[16px] text-[#949599]'>
                                    Email
                                </label>
                                <div className='truncate pr-[16px] text-primary'>
                                    <Link
                                        to={`mailto:${medicalProf?.person?.email}`}
                                    >
                                        {medicalProf?.person?.email}
                                    </Link>
                                </div>
                            </div>
                            <div className='mb-[16px] w-1/3'>
                                <label className='text-[12px]/[16px] text-[#949599]'>
                                    Address
                                </label>
                                <div>
                                    <div>{medicalProf?.person?.address_1}</div>
                                    <div>{medicalProf?.person?.address_2}</div>
                                    <div>
                                        {medicalProf?.person?.city},{' '}
                                        {medicalProf?.person?.state}{' '}
                                        {medicalProf?.person?.zip_code}
                                    </div>
                                </div>
                            </div>
                            <div className='mb-[16px] w-1/3'>
                                <label className='text-[12px]/[16px] text-[#949599]'>
                                    Professional Type
                                </label>
                                <div>
                                    {
                                        medicalProf?.medical_professional_type
                                            ?.name
                                    }
                                </div>
                            </div>
                            <div className='mb-[16px] w-1/3'>
                                <label className='text-[12px]/[16px] text-[#949599]'>
                                    Medical Center
                                </label>
                                <div className='flex items-center gap-1'>
                                    {medicalProf?.medical_center?.id ? (
                                        <Link
                                            to={`/medical-centers/${medicalProf.medical_center.id}`}
                                            className='text-primary'
                                        >
                                            {medicalProf.medical_center.name}
                                        </Link>
                                    ) : (
                                        medicalProf?.medical_center?.name
                                    )}
                                    {medicalProf?.medical_center
                                        ?.approved_by_person_id ? (
                                        <span
                                            title='Verified'
                                            className='inline-flex rounded-full bg-[#6BB841] px-2 py-0.5 text-[10px]/[14px] font-medium uppercase text-white'
                                        >
                                            Verified
                                        </span>
                                    ) : medicalProf?.medical_center?.id ? (
                                        <span
                                            title='Awaiting verification'
                                            className='inline-flex rounded-full bg-warning px-2 py-0.5 text-[10px]/[14px] font-medium uppercase text-black'
                                        >
                                            Unverified
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                            <div className='mb-[16px] w-1/3'>
                                <label className='text-[12px]/[16px] text-[#949599]'>
                                    Specialty
                                </label>
                                <div>{medicalProf?.medical_reason?.name}</div>
                            </div>
                            <div className='mb-[16px] w-1/3'>
                                <label className='text-[12px]/[16px] text-[#949599]'>
                                    Type
                                </label>
                                {medicalProf?.medical_issues?.map(
                                    (medicalIssue: any, index: number) => (
                                        <div key={index}>
                                            {medicalIssue?.name}
                                        </div>
                                    ),
                                )}
                            </div>
                            <div className='mb-[16px] w-1/3'>
                                <label className='text-[12px]/[16px] text-[#949599]'>
                                    Phone
                                </label>
                                {medicalProf?.person?.phone_set?.map(
                                    (phone: any, index: number) =>
                                        phone?.phone && (
                                            <div key={index}>
                                                {phone?.type && (
                                                    <span className='font-medium'>{`${phone?.type}: `}</span>
                                                )}
                                                {phone?.phone}
                                            </div>
                                        ),
                                )}
                            </div>
                        </div>
                    </div>
                    <button
                        className='rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-black hover:bg-black hover:text-white'
                        onClick={() => {
                            setIsDrawerOpen(true);
                        }}
                    >
                        Edit
                    </button>
                </div>
            </Panel>
            <MedicalProfessionalDrawer
                isOpen={isDrawerOpen}
                setIsOpen={setIsDrawerOpen}
                medProf={medicalProf}
                setMedicalProf={setMedicalProf}
                professionalChoices={professionalChoices}
            />
        </>
    );
};

export default MedicalProfessionalPanel;
